$(document).ready(function(){
'use strict';
    // mobile menu
    function mobile() {
        const toggleMobileNav = $(".header-nav-toggle");
        const toggleMobileNavOpen = "header-nav-toggle--open";
        const mobileNav = $(".header-nav");
        const body = $(".body");
        const mobileNavOverlay = $(".header-nav-overlay");
        const bodyIsLocked = "body-is-locked";
        const mobileNavOverlayIsLocked = "header-nav-overlay--locked";
        const mobileNavOpen = "header-nav--open";
        const mobileMenuLink = $(".header-nav__link");
        const parent = '.header-nav__menu';
        const trigger = '.header-nav__link';
        const item = '.header-submenu';
        const itemActiveClass = 'is-active';
        toggleMobileNav.on("click", function(e) {
            $(this).toggleClass(toggleMobileNavOpen);
            mobileNav.toggleClass(mobileNavOpen);
            mobileNavOverlay.toggleClass(mobileNavOverlayIsLocked);
            body.toggleClass(bodyIsLocked);
        });
        mobileNavOverlay.on("click", function(e) {
            $(this).removeClass(mobileNavOverlayIsLocked);
            toggleMobileNav.removeClass(toggleMobileNavOpen);
            mobileNav.removeClass(mobileNavOpen);
            body.removeClass(bodyIsLocked);
        });

        mobileMenuLink.on('click', function() {
            if(!$(this).hasClass(itemActiveClass)) {
                $(this).addClass(itemActiveClass);
            } else {
                $(this).removeClass(itemActiveClass);
            }
        });
        body.on('click', function(event) {
            if ($(event.target).closest(parent).length) return;
            mobileMenuLink.removeClass(itemActiveClass);
        });
    };
    mobile();

    // example carousel
    (function() {
        const $carouselDemo = $('.carousel-demo');
        $carouselDemo.slick({
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            responsive: [
                {
                  breakpoint: 1200,
                  settings: {
                    vertical: false,
                    verticalSwiping: false,
                  },
                },
              ],
          });
    }());

    // reviews carousel
    (function() {
        const $carouselReview = $('.carousel-review');
        $carouselReview.slick({
            infinite: false,
          });
    }());

    // spoiler
    (function (){
        const $faqItem = $('.faq__item');
        const $faqHead = $('.faq__head');
        const $faqBody = $('.faq__body');
        const $one = 'one';
        const $isActive = 'is-active';
        $faqHead.on('click', function(event) {
            if(($faqItem).hasClass($one)) {
                $faqHead.not($(this).removeClass($isActive));
                $faqBody.not($(this).next()).slideUp(150);
            }
            $(this).toggleClass($isActive).next().slideToggle(150);
        });
    })();

    // card animation
    (function (){
        const $infoItem = $('.info__item');
        const $viewportCheckerOpt = {classToAdd:'visible animate__animated animate__fadeInUp',offset:100};
        if ($infoItem.length) {
            $infoItem.viewportChecker($viewportCheckerOpt);
        }
    })();

    // card numbering
    (function (){
        const $infoListCount = $('.info__list');
        const $infoItemCount = '.info__item';
        const $infoNumCount = '.info__num';
        $infoListCount.each(function(){
          $($infoItemCount, this).each(function(i){
            $(this).find($infoNumCount).text(('0' + (i+1)).slice(-2));
          });
        });
    })();

    // sticky list
    (function (){
        const stickyBlock = $('.js-sticky-block');
        const stickyBlockParent = $('.privacy__sidebar');
        if (stickyBlock.length && stickyBlockParent.length) {
            const block_pos = stickyBlock.offset().top;
            const wrap_pos = stickyBlockParent.offset().top;
            const block_height = stickyBlock.outerHeight();
            const wrap_height = stickyBlockParent.outerHeight();
            const block_width = stickyBlock.outerWidth();
            const pos_absolute = wrap_pos + wrap_height - block_height;
            $(window).scroll(function () {
                if ($(window).scrollTop() > pos_absolute) {
                    stickyBlock.css({
                        'position': 'absolute',
                        'top': wrap_height - block_height,
                        'width': block_width
                    });
                }
                else if ($(window).scrollTop() > block_pos) {
                    stickyBlock.css({
                        'position': 'fixed',
                        'top': '20px',
                        'width': block_width
                    });
                } else {
                    stickyBlock.css({
                        'position': 'static'
                    });
                }
            });
        };
    })();

    // sticky list active item
    (function (){
        const $item = $('.js-sticky-block').find('a');
        const $ItemActiveClass = 'is-active';
        $item.each(function(a){
            $(this).on('click', function() {
                $item.removeClass($ItemActiveClass).eq(a).addClass($ItemActiveClass);
            });
        });
    })();

    // scroll to selected anchor
    (function (){
        const $item = $('.js-sticky-block').find('a');
        const $root = $('html, body');
        const $animDl = 150;
        const $attr = 'href';
        if ($item.length) {
            $item.on('click', function(e){
                const $anchor = $(this);
                $root.stop().animate({
                    scrollTop: $($anchor.attr($attr)).offset().top-20
                }, $animDl);
                e.preventDefault();
                return false;
            });
        }
    }());

    // add country code on telephone numbers
    (function (){
        const $tel = $('#tel');
        $tel.intlTelInput({
            nationalMode: false,
            separateDialCode: true,
        });
    }());

    // custom select
    (function (){
            $('#select').multipleSelect()
    }());
});
